import { render } from "./CopyrightInfo.vue?vue&type=template&id=1cda482a&scoped=true&ts=true"
import script from "./CopyrightInfo.vue?vue&type=script&lang=ts"
export * from "./CopyrightInfo.vue?vue&type=script&lang=ts"

import "./CopyrightInfo.vue?vue&type=style&index=0&id=1cda482a&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cda482a"]])

export default __exports__